import React from 'react';
import { getChargeTitle } from 'components/Reports/Report/lib/screenings';
import { Account } from 'types/account';
import { PromptGroup } from 'types/candidateStories';
import {
  CandidateStoryDocsForm,
  CandidateStoryPromptTextForm,
  CandidateStoryPromptFileForm,
} from '../Common';
import {
  CandidateStoryHeader,
  CandidateStoryItemTitle,
  TranslatedParagraph,
} from '../../../../Common';
import CaseInformationTextForm from './CaseInformationTextForm';
import { CANS_STEP_PROVIDE } from '../../../../../../../../../../constants';
import { settingIsEnabled } from '../../../../../../../../../../lib/helpers';

type Props = {
  account: Account;
  candidateStories: Record<string, any>;
  currentCaseId: string;
  generalInformation: boolean;
  order: number;
  record: Record<string, any>;
  remove: (index: number, field: string) => void;
  selectedItems: number;
  promptGroup?: PromptGroup;
};

const CaseInformationForm = ({
  account,
  candidateStories,
  currentCaseId,
  generalInformation,
  order,
  record,
  remove,
  selectedItems,
  promptGroup,
}: Props) => {
  const setting = account.candidateStoriesRecordsInfo;
  const docsEnabled = settingIsEnabled(setting, {
    nullish: true,
    keys: ['docs'],
  });
  const textEnabled = settingIsEnabled(setting, {
    nullish: true,
    keys: ['text'],
  });

  if (!candidateStories[record.id]) {
    candidateStories[record.id] = { documents: [] };
  }
  const chargeName = getChargeTitle(record);

  const removeDocuments = (i: number) => {
    remove(i, `candidateStories.${record.id}.documents`);
  };

  const step = generalInformation ? order + 1 : order;

  const hasPromptGroup = promptGroup !== undefined;

  if (hasPromptGroup) {
    if (!candidateStories.promptGroup) {
      candidateStories.promptGroup = {};
    }
    if (!candidateStories.promptGroup[record.id]) {
      candidateStories.promptGroup[record.id] = {};
    }
  }

  return (
    currentCaseId === record.id && (
      <div>
        <CandidateStoryHeader
          step={CANS_STEP_PROVIDE}
          provide_step={step}
          provide_total={selectedItems}
        />
        <div className='form-question-wrapper'>
          <h4 className='form-question'>
            <CandidateStoryItemTitle record={record} />
          </h4>
          <TranslatedParagraph
            value='components.Report.CandidateStories.Modal.CaseInformation.description'
            interpolationValues={{
              company: account.name,
              chargeName,
            }}
          />
        </div>
        <div>
          {hasPromptGroup ? (
            <div data-testid='candidate-stories-prompt-forms'>
              <CandidateStoryPromptTextForm
                promptGroup={promptGroup}
                disabled={!textEnabled}
                recordId={record.id}
                account={account}
              />
              <CandidateStoryPromptFileForm
                promptGroup={promptGroup}
                disabled={!docsEnabled}
                promptDocuments={candidateStories.promptGroup?.[record.id]}
                remove={remove}
                recordId={record.id}
              />
            </div>
          ) : (
            <div data-testid='candidate-stories-legacy-forms'>
              <CaseInformationTextForm
                charge={chargeName}
                disabled={!textEnabled}
                field={`candidateStories.content.${record.id}`}
              />
              <CandidateStoryDocsForm
                documents={candidateStories[record.id].documents}
                disabled={!docsEnabled}
                field={`candidateStories.${record.id}.documents`}
                remove={removeDocuments}
              />
            </div>
          )}
        </div>
      </div>
    )
  );
};

export default CaseInformationForm;
